import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CourseSkeletonComponent } from './course-skeleton.component';

@NgModule({
  declarations: [CourseSkeletonComponent],
  imports: [CommonModule],
  exports: [CourseSkeletonComponent],
})
export class CourseSkeletonModule {}
